"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _IndicatorButton = _interopRequireDefault(require("../IndicatorButton"));
var _icons = require("../../icons");
var _enums = require("../../../types/enums");
var _context = require("../../../context");
var _constants = require("../../../constants");
var _linkIndicator = require("./link-indicator.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const CopySuccessTooltipContent = /*#__PURE__*/_react.default.createElement("div", {
  className: _linkIndicator.contentWrapperStyle
}, _icons.successIcon, _constants.messages.linkCopied);
const LinkIndicatorButton = () => {
  const {
    currentBuildStatus,
    trackEvent
  } = (0, _react.useContext)(_context.IndicatorContext);
  const baseButtonProps = {
    icon: _icons.linkIcon,
    testId: `link`,
    clickable: false,
    disabled: true
  };
  const [buttonProps, setButtonProps] = (0, _react.useState)(baseButtonProps);
  const onCopyLinkClick = () => {
    trackEvent({
      eventType: _enums.EventType.PREVIEW_INDICATOR_CLICK,
      name: `copy link`
    });
    setButtonProps(btnProps => {
      const newProps = {
        ...btnProps
      };
      if (newProps.tooltip) {
        newProps.tooltip.content = CopySuccessTooltipContent;
        newProps.tooltip.visible = true;
        newProps.tooltip.trigger = `none`;
      }
      return newProps;
    });
    setTimeout(() => {
      setButtonProps(btnProps => {
        const newProps = {
          ...btnProps
        };
        if (newProps.tooltip) {
          newProps.tooltip.visible = false;
          newProps.tooltip.trigger = `hover`;
        }
        return newProps;
      });
      // We want the tooltip to linger for two seconds to let the user know it has been copied
    }, 2000);
    if (window) {
      navigator.clipboard.writeText(window.location.href);
    }
  };
  const onMouseEnter = () => {
    trackEvent({
      eventType: _enums.EventType.PREVIEW_INDICATOR_HOVER,
      name: `link hover`
    });
  };
  (0, _react.useEffect)(() => {
    if (currentBuildStatus === _enums.BuildStatus.BUILDING || currentBuildStatus === _enums.BuildStatus.UP_TO_DATE) {
      const onTooltipClose = () => {
        setButtonProps(btnProps => {
          const newProps = {
            ...btnProps
          };
          if (newProps.tooltip) {
            newProps.tooltip.content = _constants.messages.copyLink;
            newProps.tooltip.trigger = `hover`;
          }
          return newProps;
        });
      };
      setButtonProps(btnProps => {
        const newProps = {
          ...btnProps,
          ...baseButtonProps
        };
        newProps.disabled = false;
        newProps.clickable = true;
        newProps.disabled = false;
        newProps.onClick = onCopyLinkClick;
        newProps.tooltip = {
          content: _constants.messages.copyLink,
          trigger: `hover`,
          onDisappear: onTooltipClose
        };
        return newProps;
      });
    } else {
      setButtonProps(baseButtonProps);
    }
  }, [currentBuildStatus]);
  return /*#__PURE__*/_react.default.createElement(_IndicatorButton.default, (0, _extends2.default)({
    onMouseEnter: !buttonProps.disabled ? onMouseEnter : undefined
  }, buttonProps));
};
var _default = LinkIndicatorButton;
exports.default = _default;